import { PickupEventDetailPage } from "components/shared/pickupEvents";

export const PickupEventDetail: React.FC = () => (
  <PickupEventDetailPage variant="admin" />
);
